module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-month-5-37325231774b020b7067d4cd69d16abf.svg";